<template>

    <div v-observe-visibility="visibilityChanged">

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>
                <v-card dark color="secondary">
                    <v-card-title>Branch Office</v-card-title>
                </v-card>
                <v-progress-linear class="branch-office-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>
                <v-autocomplete
                        :items="supplierBranchOffices"
                        item-text="name"
                        item-value="id"
                        label="Select Branch Office"
                        v-model="selectedBranchOffice"
                        required
                ></v-autocomplete>
            </v-flex>
        </v-layout>


        <v-layout row wrap>
            <v-container>

                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs12>

                            <v-card v-if="tableDisabled">
                                <v-card-title>
                                    Manufacturers
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getManufacturers"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <v-checkbox
                                                        v-model="props.item.selected"
                                                        color="secondary"
                                                        hide-details
                                                        @change="selectedManufacturers(props.item.id, props.item.selected)"
                                                ></v-checkbox>
                                            </td>
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.website }}</td>
                                            <td class="text-xs-left">{{ props.item.email }}</td>
                                        </tr>

                                    </template>
                                </v-data-table>
                            </v-card>

                            <v-card v-else xs12 md4>
                                <v-container>
                                    <v-card-text class="text-xs-center">Select a Branch Office</v-card-text>
                                </v-container>

                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-flex>
            </v-container>
        </v-layout>

    </div>
</template>

<script>
    // Types
    import {
        Settings,
        ManufacturersSettings
    } from '../../../store/namespace-helper'

    import _ from 'lodash'

    export default {
      name: 'BranchOfficesManufacturers',
      components: {},
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Select Manufacturer', value: 'selected', sortable: false},
                    {text: 'Manufacturer-ID', value: 'id'},
                    {text: 'Manufacturer Name', value: 'name'},
                    {text: 'Website', value: 'website'},
                    {text: 'E-Mail', value: 'email'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250],
          selectedBranchOffice: null,
          selected: []
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('Suppliers tab visible, load data')
              this.loadSupplierBranchOffices()
            } else {
              this.selectedBranchOffice = null
            }
          }
        },
        loadManufacturers: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            branch_office_id: this.selectedBranchOffice
          }
          this.$store.dispatch(ManufacturersSettings.actions.loadManufacturers, query)
        },
        throttledLoadManufacturers: _.debounce(function () {
          this.loadManufacturers()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        selectedManufacturers (manufacturerId, selected) {
          let branchOfficeHasManufacturer = {
            supplier_branch_offices_id: this.selectedBranchOffice,
            manufacturer_id: manufacturerId,
            selected: selected
          }
          this.$store.dispatch(ManufacturersSettings.actions.saveBranchOfficeHasManufacturers, branchOfficeHasManufacturer)
        },
        loadSupplierBranchOffices () {
          this.$store.dispatch(Settings.actions.loadSupplierBranchOffices, this.selectedSupplier.id)
        },
        loadBranchOfficeHasManufacturers () {
          this.$store.dispatch(ManufacturersSettings.actions.loadBranchOfficeHasManufacturers, this.selectedBranchOffice)
        }

      },
      computed: {
        selectedSupplier () {
          return this.$store.getters[Settings.getters.getSelectedSupplier]
        },
        supplierBranchOffices () {
          if (this.$store.getters[Settings.getters.getSupplierBranchOffices] == null) {
            return []
          }
          return this.$store.getters[Settings.getters.getSupplierBranchOffices]
        },
        getManufacturers () {
          this.total = this.$store.getters[ManufacturersSettings.getters.manufacturers].total
          return this.$store.getters[ManufacturersSettings.getters.manufacturers].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        tableDisabled () {
          return !!this.selectedBranchOffice
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadManufacturers()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadManufacturers()
          },
          deep: true
        },
        selectedBranchOffice: {
          handler (val) {
            console.log('selectedBranchOffice data changed: ' + JSON.stringify(val))
                    // Load manufacturers
            this.loadManufacturers()
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

    .branch-office-loading {
        margin-top: 0px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Settings/Suppliers/BranchOfficesManufacturers.vue